define('model/external.association.model',['require','exports','module','lodash','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var lodash    = require('lodash'),
      BaseModel = require('fukit/fukit').BaseModel;

  var ExternalAssociationModel = BaseModel.extend({
    radioRequests: {
      'models ExternalAssiciationModel': '@constructor',
    },

    urlRootTemplate: '/api/v2/person/external-affiliation',

    defaults: {
      active: true,
    },

    // TODO: when person-service is updated to send the correct
    //  href for _links.self, this should be removed.
    parse: function(resp, options) {
      var dataWithNewLink = Object.assign({}, resp);
      var selfHref = this.urlRootTemplate + '/' + resp.id;
      lodash.set(dataWithNewLink, '_links.self.href', selfHref);
      return BaseModel.prototype.parse.apply(this, [dataWithNewLink, options]);
    },

    relationships: {
      organization: {
        foreignKey: 'organizationId',
        resourceClass: 'OrganizationModel',
        type: 'belongsTo',
      },
    },
  });

  module.exports = ExternalAssociationModel;
});

